// extracted by mini-css-extract-plugin
module.exports = {"scannerBtn":"ProductScanner_scannerBtn__2YQjY","notDisplay":"ProductScanner_notDisplay__1_Tdq"};